/**
 * @Author: abbeymart | Abi Akindele | @Created: 2020-07-03 | @Updated: 2020-07-04
 * @Company: mConnect.biz | @License: MIT
 * @Description: home routes - home, mc, central, mpe, etc.
 */

import type { RouteRecordRaw } from 'vue-router';

export const homeRoutes: Array<RouteRecordRaw> = [
  {
    path: '',
    name: 'home',
    component: () => import('pages/McHome.vue'),
    meta: {
      title: 'Marketplace Solutions & Services',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/',
    name: 'home',
    component: () => import('pages/McHome.vue'),
    meta: {
      title: 'Marketplace Solutions & Services',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/mc',
    name: 'mc',
    component: () => import('pages/mc/MarketplaceConnect.vue'),
    meta: {
      title: 'Marketplace Solutions & Services',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/home',
    redirect: '/',
    component: () => import('pages/McHome.vue'),
    meta: {
      title: 'Marketplace Solutions & Services',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/central',
    name: 'central',
    component: () => import('pages/central/McCentral.vue'),
    meta: {
      title: 'Shared Services',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/microservice',
    name: 'microservice',
    component: () => import('pages/micros/MicroService.vue'),
    meta: {
      title: 'Microservices [policy automation, payment-service, shipping-service...]',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/access/microservice',
    name: 'msaccess',
    component: () => import('pages/micros/MicroserviceAccess.vue'),
    meta: {
      title: 'Microservices [policy automation, payment-service, shipping-service...]',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/infomarket',
    name: 'infomarket',
    component: () => import('pages/info/McInfo.vue'),
    meta: {
      title: 'Information Marketplace',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/info',
    name: 'info',
    component: () => import('pages/info/McInfo.vue'),
    meta: {
      title: 'Information Marketplace',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/asset',
    name: 'asset',
    component: () => import('pages/asset/AssetManagement.vue'),
    meta: {
      title: 'Asset Management Solutions',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/mpe',
    name: 'mpe',
    component: () => import('pages/mpe/MarketplaceExplorer.vue'),
    meta: {
      title: 'Marketplace Explorer Solutions & Solutions',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/trade',
    name: 'trade',
    component: () => import('pages/trade/McTrade.vue'),
    meta: {
      title: 'Marketplace Trading Solutions',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/services',
    name: 'services',
    component: () => import('pages/services/McServices.vue'),
    meta: {
      title: 'Marketplace Services Delivery Solutions',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/pam',
    name: 'pam',
    component: () => import('pages/pam/McPlanning.vue'),
    meta: {
      title: 'Planning & Activity Management Solutions',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/hcm',
    name: 'hcm',
    component: () => import('pages/hcm/HumanCapital.vue'),
    meta: {
      title: 'Human Capital Management Solutions',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/finance',
    name: 'finance',
    component: () => import('pages/fin/McFinance.vue'),
    meta: {
      title: 'Financial Management Solutions',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/hms',
    name: 'hms',
    component: () => import('pages/hms/HospitalManagement.vue'),
    meta: {
      title: 'Hospital Management Solutions',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/sdm',
    name: 'sdm',
    component: () => import('pages/sdm/ServicesDelivery.vue'),
    meta: {
      title: 'Service Delivery Management Solutions',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/ems',
    name: 'ems',
    component: () => import('pages/ems/EducationManagement.vue'),
    meta: {
      title: 'Education Management Solutions',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/dm',
    name: 'dm',
    component: () => import('pages/dm/DataManagement.vue'),
    meta: {
      title: 'Data Management Solutions',
      byQueryParams: false,
    },
    children: [],
  },
  {
    path: '/bi',
    name: 'bi',
    component: () => import('pages/bi/BusinessIntelligence.vue'),
    meta: {
      title: 'Business Intelligence Solutions',
      byQueryParams: false,
    },
    children: [],
  },
];
